import fetch from './fetch';
import EndPoints from '../data/EndPoints';
import Methods from '../data/Methods';

export default (data, financialYearId) => {
	return fetch(
		Methods.POST,
		EndPoints.FINANCIAL_YEAR_EXPENSE.replace(':year', financialYearId),
		data,
		null,
		true
	);
};
